/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Dictate_EmptyInputs */



/**
* | output |
* | --- |
* | "We did not hear anything. Try again." |
*
* @param {Chat_Dictate_EmptyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_dictate_empty = /** @type {((inputs?: Chat_Dictate_EmptyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Dictate_EmptyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("We hebben niets gehoord. Probeer opnieuw.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nous n'avons rien entendu. Réessayez.")
	return /** @type {LocalizedString} */ ("We did not hear anything. Try again.")
});